/** @jsx jsx */
import { jsx } from "theme-ui"
import { useTranslation } from "react-i18next"

export default function Pin({ icon, children, ...otherProps }) {
  const { i18n } = useTranslation()

  return (
    <div
      sx={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "primary",
        borderRadius: "circle",
        variant: "text.caps",
        px: 2,
        py: "3px",
      }}
      {...otherProps}
    >
      <span
        sx={{
          display: "flex",
          alignItems: "center",
          [`${i18n.dir() === "rtl" ? "ml" : "mr"}`]: 1,
        }}
      >
        {icon}
      </span>
      {children}
    </div>
  )
}
